'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' });

var Tv = function Tv(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Tv = (0, _pure2.default)(Tv);
Tv.muiName = 'SvgIcon';

exports.default = Tv;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Tv.js
// module id = 2965
// module chunks = 0